var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32251 14.6379V12.3263C4.32251 11.5583 4.92417 10.8696 5.77917 10.8696C6.54709 10.8696 7.23584 11.4713 7.23584 12.3263V14.5508C7.23584 16.0946 5.95334 17.3771 4.40959 17.3771C2.86584 17.3771 1.58334 16.0867 1.58334 14.5508V9.67417C1.49626 5.22501 5.01126 1.62292 9.46042 1.62292C13.9096 1.62292 17.4167 5.22501 17.4167 9.58709V14.4638C17.4167 16.0075 16.1342 17.29 14.5904 17.29C13.0467 17.29 11.7642 16.0075 11.7642 14.4638V12.2392C11.7642 11.4713 12.3658 10.7825 13.2208 10.7825C13.9888 10.7825 14.6775 11.3842 14.6775 12.2392V14.6379",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.9745cc52add6dcd3312e6cd90653309a.svg";
export { ForwardRef as ReactComponent };